import React from 'react';
import styled from 'styled-components';
import { Player } from '../../services/Restorative/types';

interface PlayerListProps {
  players: Player[];
  loadingPlayers: boolean;
  onPlayerClick: (name: string, id: number) => void;
}

const PlayerItem = styled.li(({ theme }) => {
  return `
  padding: 12px 16px;
  cursor: pointer;
  &:hover {
    background-color: lightgray;
  }

  @media (max-width: ${theme.new.breakpoint.tabletLarge.down}) {
    padding: 8px 16px;
    font-size: ${theme.new.type.size[14]};
  }
`;
});

const BankContainer = styled.div(({ theme }) => {
  return `
    overflow-y: auto;
    height: 230px;


    @media (max-width: ${theme.new.breakpoint.tabletLarge.down}) {
      height: 150px;
    }
  `;
});

const LoadingMessage = styled.div(({ theme }) => {
  return `
    font-size: ${theme.new.type.size[14]};
  `;
});

const ActivityAttributionPlayerBank: React.FC<PlayerListProps> = ({ players, onPlayerClick, loadingPlayers }) => {
  return (
    <BankContainer>
      {!loadingPlayers && players.length > 0 && (
        <ul>
          {players.map((player) => (
            <PlayerItem key={player.id} onClick={() => onPlayerClick(player.name, player.id)}>
              {player.name}
            </PlayerItem>
          ))}
        </ul>
      )}

      {!loadingPlayers && players.length === 0 && <div>No residents to show</div>}
      {loadingPlayers && (
        <LoadingMessage>
          Loading Residents... <i className="fa fa-spin fa-spinner"></i>
        </LoadingMessage>
      )}
    </BankContainer>
  );
};

export default ActivityAttributionPlayerBank;
